import Dispatcher from '../dispatcher/CentricDispatcher.react.js';
import { ReduceStore } from 'flux/utils';
import { ActionTypes } from '../constants/CentricConstants';
import { asDate } from '../utils/Date';

const sanitize = ({id, assetId, dateAdded, dateUpdated, ...rest}) => ({
    id: Number(id),
    assetId: Number(assetId) || null,
    dateAdded: asDate(dateAdded),
    dateUpdated: asDate(dateUpdated),
    ...rest
});

class AssetHistoryStore extends ReduceStore {

    getInitialState() {
        return {
            isFetching: false,
            data: []
        };
    }

    isFetching() {
        return this.getState().isFetching;
    }

    getByAssetId(assetId) {
        return this.getState().data.filter((e) => !!e && e.assetId === assetId)
    }

    reduce(state, action) {
        let assetId;
        switch (action.type) {
            case ActionTypes.ASSET_HISTORY_REQUEST:
                return ({
                    ...state,
                    isFetching: true
                });
            case ActionTypes.ASSET_HISTORY_SUCCESS:
                assetId = Number(action.payload.assetId);
                return ({
                    ...state,
                    data: [
                        ...state.data.filter((e, i) => !!e && e.assetId !== assetId),
                        ...action.data.map(sanitize)
                    ],
                    isFetching: false,
                });
            case ActionTypes.ASSET_HISTORY_FAILURE:
                return ({
                    state,
                    isFetching: false
                });
            default:
                return state;
        }
    }
}

export default new AssetHistoryStore(Dispatcher);
